import { ContactType } from '../index';

export interface IContact {
    id?: string;
    type: ContactType;
    data: string;
    primaryContact: boolean;
}

export interface IContactForm {
    contacts: IContact[];
}

export const ContactDefaults: IContact = {
    id: undefined,
    type: ContactType.Email,
    data: '',
    primaryContact: false,
};
